__turbopack_context__.v({
  "card": "auth-module__Y2OPrW__card",
  "divider": "auth-module__Y2OPrW__divider",
  "error": "auth-module__Y2OPrW__error",
  "errorActions": "auth-module__Y2OPrW__errorActions",
  "forgotLink": "auth-module__Y2OPrW__forgotLink",
  "forgotLinkWrapper": "auth-module__Y2OPrW__forgotLinkWrapper",
  "form": "auth-module__Y2OPrW__form",
  "googleButtonContent": "auth-module__Y2OPrW__googleButtonContent",
  "googleIcon": "auth-module__Y2OPrW__googleIcon",
  "heading": "auth-module__Y2OPrW__heading",
  "links": "auth-module__Y2OPrW__links",
  "logo": "auth-module__Y2OPrW__logo",
  "logoText": "auth-module__Y2OPrW__logoText",
  "page": "auth-module__Y2OPrW__page",
  "subheading": "auth-module__Y2OPrW__subheading",
  "success": "auth-module__Y2OPrW__success",
  "successBanner": "auth-module__Y2OPrW__successBanner",
  "successIcon": "auth-module__Y2OPrW__successIcon",
  "successText": "auth-module__Y2OPrW__successText",
  "successTitle": "auth-module__Y2OPrW__successTitle",
});
